import { FormInstance } from 'antd/lib/index'
import {
  UserManagementForm,
  UserManagementFormFieldTypes,
} from '../../user-management-form/user-management-form.tsx'
import IdeyaModal from '../../../../../common/antd/ideya-modal.tsx'
import { useGetUserQuery } from '../../../../../apis/user-management/user-management-api.api.ts'
import { useEffect } from 'react'
import {
  AccountRegion,
  AccountType,
} from '../../../../../enums/management-input.enum.ts'
import { IdeyaSpinner } from '../../../../../common/components/ideya-spinner.tsx'
import { useTranslation } from 'react-i18next'

interface ActionUserModalProps {
  showActionModal: boolean
  form: FormInstance<UserManagementFormFieldTypes>
  handleCloseModal: () => void
  editUserId?: string | null
  setEditUserId: (id: string | null) => void
}

export const ActionUserModal: React.FC<ActionUserModalProps> = ({
  showActionModal,
  form,
  handleCloseModal,
  editUserId,
  setEditUserId,
}) => {
  const { t } = useTranslation()
  const {
    currentData: editUser,
    isLoading: isLoadingEdit,
    isFetching: isFetchingEdit,
  } = useGetUserQuery(editUserId ?? '', { skip: !editUserId })

  useEffect(() => {
    if (editUser) {
      form.setFieldsValue({
        fullName: editUser.data.fullName,
        email: editUser.data.email,
        accountType: editUser.data.accountType as AccountType,
        firmRole: editUser.data.firmRole,
        firmId: editUser.data.firm?.id,
        isTrial: editUser.data.isTrial,
        groupId: editUser.data.group?.id ?? 'All',
        groupRole: editUser.data.groupRole,
        subRegion:
          editUser.data.group?.region === AccountRegion.GreaterChina
            ? editUser.data.subRegion
            : undefined,
        groupPermission: editUser.data.groupPermission,
        internalRole: editUser.data.internalRole,
        externalId: editUser.data.externalId,
      })
    }
  }, [editUserId, editUser, form])

  const handleCloseAndClear = () => {
    setEditUserId(null)
    handleCloseModal()
    form.resetFields()
  }

  return (
    <IdeyaModal
      open={showActionModal}
      title={
        editUserId
          ? t('user_management.user_modal.action_user_modal.edit_user')
          : t('user_management.user_modal.action_user_modal.add_user')
      }
      destroyOnClose
      isForm={true}
      onCancel={handleCloseAndClear}
    >
      {isFetchingEdit || isLoadingEdit ? (
        <IdeyaSpinner />
      ) : (
        <UserManagementForm
          editUser={editUser?.data}
          mode={editUserId ? 'edit' : 'create'}
          form={form}
          onCancel={handleCloseAndClear}
        />
      )}
    </IdeyaModal>
  )
}
